import { Box } from '../Box'
import { SpinnerProps } from '../../../types/atoms'
import { background, layout, position, space } from 'styled-system'
import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  0%{
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
 `

const Spin = styled(Box)`
  height: inherit;
  width: inherit;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.primary.black};
  border-radius: 50%;
  position: relative;
  animation: ${rotate} 1s infinite linear;

  &::before,
  &::after {
    content: '';
    position: absolute;
  }

  &::before {
    border-radius: 50%;
    background: linear-gradient(0deg, hsla(0, 0%, 100%, 1) 50%, hsla(0, 0%, 100%, 0.9) 100%) 0% 0%,
      linear-gradient(90deg, hsla(0, 0%, 100%, 0.9) 0%, hsla(0, 0%, 100%, 0.6) 100%) 100% 0%,
      linear-gradient(180deg, hsla(0, 0%, 100%, 0.6) 0%, hsla(0, 0%, 100%, 0.3) 100%) 100% 100%,
      linear-gradient(360deg, hsla(0, 0%, 100%, 0.3) 0%, hsla(0, 0%, 100%, 0) 100%) 0% 100%;
    background-repeat: no-repeat;
    background-size: 50% 50%;
    top: -1px;
    bottom: -1px;
    left: -1px;
    right: -1px;
  }

  &::after {
    background: white;
    border-radius: 50%;
    top: 3%;
    bottom: 3%;
    left: 3%;
    right: 3%;
  }
  ${layout}
  ${position}
  ${space}
  ${background}
`

export const GradientSpinner = (props: SpinnerProps): JSX.Element => {
  return <Spin {...props} />
}
